import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultTextField from 'components/Utils/DefaultTextField';
import DefaultButton from 'components/Utils/NewDefaultButton';

const PackYearCalculatorModal = (props) => {
  let [cigarettes, setCigarettes] = useState(0);
  let [years, setYears] = useState(0);

  let result = calculatePackYear(cigarettes, years);
  let buttonEnabled = isNumber(result);

  function calculatePackYear(cigarretes, years) {
    if (!isNumber(cigarretes) || !isNumber(years)) return 'N/A';

    return (cigarretes / 20.0) * years;
  }

  function isNumber(value) {
    let intVal = parseInt(value, 10);
    let floatVal = parseFloat(value);
    return '' + value !== '0' && ('' + value === '' + intVal || '' + value === '' + floatVal);
  }

  function copyToClipboard() {
    navigator.clipboard.writeText(result);
  }

  return (
    <div className="modal h-full" style={{ width: '300px' }}>
      <div className="title">Pack-Year Calculator</div>
      <div className="padded-box" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <DefaultTextField
          name="cigarettes"
          label="Cigarettes per day"
          value={cigarettes}
          onChange={(event) => setCigarettes(event.target.value)}
        />
        <DefaultTextField
          name="years"
          label="Years"
          value={years}
          onChange={(event) => setYears(event.target.value)}
        />
        <DefaultTextField name="result" label="Result" value={result} disabled={true} />
        {!!props.onSubmit && (
          <DefaultButton
            name="Save"
            onClick={() => props.onSubmit(result)}
            style={{ width: '100%' }}
            disabled={!buttonEnabled}
          />
        )}
        {!props.onSubmit && (
          <DefaultButton
            name="Copy to Clipboard"
            onClick={copyToClipboard}
            style={{ width: '100%' }}
            disabled={!buttonEnabled}
          />
        )}
      </div>
    </div>
  );
};

PackYearCalculatorModal.propTypes = {
  onSubmit: PropTypes.func,
};

export default PackYearCalculatorModal;
